import React from 'react';

const Google = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    {...props}
  >
    <path d="M18,10.1866641 C18,14.751996 14.8225871,17.999995 10.1310019,17.999995 C7.97379233,18.0023573 5.9042462,17.1602614 4.37886773,15.6594585 C2.85348926,14.1586555 1.99760413,12.1224521 2.00000504,9.99999752 C2.00000504,5.57422112 5.63275375,2 10.1310019,2 C12.3209504,2 14.1639764,2.79111087 15.583287,4.09333268 L13.369849,6.18666537 C10.4752141,3.43999955 5.09159074,5.50311003 5.09159074,9.99999752 C5.09159074,12.7911078 7.35742853,15.0515515 10.1310019,15.0515515 C13.3508767,15.0515515 14.557878,12.7804411 14.7476012,11.6026637 L10.1310019,11.6026637 L10.1310019,8.85244232 L17.8717109,8.85244232 C17.9476002,9.26221997 18,9.65599763 18,10.187553 L18,10.1866641 Z" />
  </svg>
);

export default Google;
